import React, { useCallback } from 'react';
import { Flex, Box, Button } from 'rebass';
import { useTranslation } from 'react-i18next';

import useCart from 'hooks/usecart';
import Checkout from 'components/checkout';
import {
  ORDER_TYPE_SELECTION,
  ORDER_TYPE_DOWNLOAD,
} from 'components/cartprovider';

const ACTIONS_BUTTON_LABELS = {
  [ORDER_TYPE_SELECTION]: 'checkoutbar.sendselection',
  [ORDER_TYPE_DOWNLOAD]: 'checkoutbar.download',
};

const CheckoutBar = ({ gallery, studio }) => {
  const [cart, dispatch] = useCart();
  const { t } = useTranslation();
  const nbItems = cart.selection.length;

  if (!gallery?.actions || gallery.actions.length === 0) {
    return null;
  }

  const addAll = useCallback(() => {
    dispatch({ type: 'empty' });
    gallery.photos.forEach((photo) =>
      dispatch({ type: 'add', id: photo.id, galleryId: gallery.id })
    );
  }, [gallery, dispatch]);

  const onSubmit = (action) => async () => {
    dispatch({
      type: 'set_order_type',
      id: action.type,
    });
  };

  return (
    <>
      <Flex
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          padding: 3,
          backgroundColor: 'white',
          boxShadow: 'large',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <Box>
          {t('checkoutbar.count', { count: nbItems })}
          {nbItems === 0 && (
            <Button
              onClick={addAll}
              variant="link"
              sx={{
                fontSize: 0,
              }}
            >
              {t('checkoutbar.selectall')}
            </Button>
          )}
          {nbItems > 0 && (
            <Button
              onClick={() => dispatch({ type: 'empty' })}
              variant="link"
              sx={{
                fontSize: 0,
              }}
            >
              {t('checkoutbar.clear')}
            </Button>
          )}
        </Box>
        <Box sx={{ marginLeft: 'auto' }}>
          {gallery?.actions.map((action) => (
            <Button
              sx={{ marginLeft: 2 }}
              disabled={nbItems === 0 || cart.orderId}
              onClick={onSubmit(action)}
              key={action.type}
            >
              {t(ACTIONS_BUTTON_LABELS[action.type])}
            </Button>
          ))}
        </Box>
      </Flex>
      {cart.orderType && <Checkout studio={studio} />}
    </>
  );
};

export default CheckoutBar;
